import styled from 'styled-components'
import { Spin } from 'antd'

const ContainerSegmentControl = styled.div`
  margin: 24px 0 12px 0;
  padding: 0 12px 0 12px;
`

const WrapOptionCancel = styled.div`
  align-self: center;
  padding-bottom: 12px;
`

const WrapSpin = styled(Spin)`
  margin-top: 16px;
`

const WrapTypography = styled.div`
  display: flex;
`

export { ContainerSegmentControl, WrapOptionCancel, WrapSpin, WrapTypography }
